// ── Ticket-Review (aus maco-knowledge-to-tools/ticket/dist/<RUN_ID>/) ────────

export type TicketRelevance = "kritisch" | "hoch" | "normal" | "gering" | "unbewertet";
export type TicketPriority = "hoch" | "normal" | "gering";
export type TicketChangeType = "added" | "modified" | "removed";

export type TicketMeta = {
  aend_id: string;
  content_hash?: string;
  status?: "draft" | "review" | "ready";
  review_needed?: boolean;
  review_reasons?: string[];
  doctype: string;            // "ebd" | "ahb" | "mig"
  format?: string;
  version?: string;
  formatversion: string;
  change_type?: TicketChangeType;
  valid_from?: string;
  status_release_date?: string;
  source_file?: string;
  edi_energy_id?: string;
  priority: TicketPriority;
  effort?: string;
  market_roles?: string[];
  confidence?: number;
  business_relevance: TicketRelevance;
  matched_components?: string[];
  matched_processes?: string[];
  out_of_scope_match?: boolean;
};

export type Ticket = TicketMeta & {
  file: string;     // Original filename, z.B. "70340__ebd__...md"
  body: string;     // Markdown body (after frontmatter)
};

export type TicketManifest = {
  tool: string;
  version: string;
  run_id: string;
  phase: string;
  source_changelog?: string;
  formatversion: string;
  entry_count: number;
  doctype_filter?: string | null;
  format_filter?: string | null;
  threshold?: number;
  stats: {
    total: number;
    ok: number;
    failed: number;
    review: number;
    auto_ok: number;
    flag_counts?: Record<string, number>;
    relevance_counts?: Record<string, number>;
    missing_drafts?: number;
  };
};

export type TicketRun = {
  run_id: string;                  // dist-Ordner-Name, z.B. "20260520-122429"
  meta_run_id?: string | null;     // Meta-Run-ID, z.B. "run-202610-2026-05-20-003"
  release?: string | null;         // z.B. "202610"
  trigger_date?: string | null;    // ISO-8601
  manifest: TicketManifest | null;
  tickets: Ticket[];
  ticket_count: number;
};

// ── Lokaler Review-State (localStorage + Export) ────────────────────────────

export type ReviewState = "pending" | "approved" | "rejected" | "in-jira";

export type ReviewDecision = {
  state: ReviewState;
  reject_reason?: string;
  edits?: { title?: string; description?: string };
  reviewed_at?: string;
  reviewed_by?: string;
  jira_key?: string;        // wenn schon angelegt
};

export type ReviewStatePayload = {
  /** runId → ticketKey → decision */
  decisions: Record<string, Record<string, ReviewDecision>>;
};

export function ticketKey(t: Pick<TicketMeta, "aend_id" | "doctype" | "content_hash">): string {
  return `${t.aend_id}::${t.doctype}::${t.content_hash ?? ""}`;
}
